'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _connectStats = require('../connectors/connectStats');

var _connectStats2 = _interopRequireDefault(_connectStats);

var _Stats = require('../components/Stats');

var _Stats2 = _interopRequireDefault(_Stats);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * The Stats component displays the total number of matching hits and the time it took to get them (time spent in the Algolia server).
 * @name Stats
 * @kind widget
 * @themeKey ais-Stats - the root div of the widget
 * @themeKey ais-Stats-text - the text of the widget - the count of items for each item
 * @translationkey stats - The string displayed by the stats widget. You get function(n, ms) and you need to return a string. n is a number of hits retrieved, ms is a processed time.
 * @example
 * import React from 'react';
 * import { InstantSearch, Stats, Hits } from 'react-instantsearch/dom';
 *
 * const App = () => (
 *   <InstantSearch
 *     appId="latency"
 *     apiKey="6be0576ff61c053d5f9a3225e2a90f76"
 *     indexName="ikea"
 *   >
 *     <Stats />
 *     <Hits />
 *   </InstantSearch>
 * );
 */

exports.default = (0, _connectStats2.default)(_Stats2.default);


//////////////////
// WEBPACK FOOTER
// ./~/react-instantsearch/src/widgets/Stats.js
// module id = 1095
// module chunks = 142807904292071